<div class="dialog-holder">
  <div class="title-wrap">
    <h2>{{ title }}</h2>
    <span class="subTitle" [innerHTML]="body"></span>
  </div>
  <div class="form-holder" *ngFor="let data of formOrder">
    <span class="label">{{ data }}</span>
    <div class="content">
      {{ fromData[data] }}
    </div>
  </div>
  <div class="action-button">
    <lib-button
      [label]="closeText"
      (click)="close()"
      type="Secondary"
      data-test-id="close-button"
      [width]="'100%'"
      style="width: 100%"
    ></lib-button>
    <lib-button
      [label]="confirmText"
      (click)="confirm()"
      data-test-id="confirm-button"
      [width]="'100%'"
      style="width: 100%"
    >
    </lib-button>
  </div>
</div>
